import gql from 'graphql-tag';
import { convertFilterRequestUrl } from '../../utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['countLimit', 'amountLimit'])}` : '';
  const getRawInterconnectVoiceReportData = `getRawInterconnectVoiceReportData(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${getRawInterconnectVoiceReportData} {
        lineDayOfMonth
        operatorId
        operatorName
        noOfMinutes
        noOfSeconds
        noOfCalls
      }
    }
  `;
};
